import emptySliceApi from '../../shared/store/emptyApiSlice';
import { UserProductAggregate } from './models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query<UserProductAggregate, { accountId: string }>({
      query: ({ accountId }) => ({
        url: `/v4/accounts/${accountId}/hub`,
        cache: 'reload',
      }),
      providesTags: ['Product'],
    }),
  }),
});

export const { useGetProductsQuery } = apiSlice;
